import React, { useState } from "react";
import { Form, Submit, TextArea, TextInput } from "thorium-ui";

export const ContactForm = (props) => {
   const [data, setData] = useState({});
   let name, email, message;

   const encode = (data) => {
      return Object.keys(data)
         .map(
            (key) =>
               encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
         )
         .join("&");
   };
   const handleSubmit = (e) => {
      fetch("/", {
         method: "POST",
         headers: { "Content-Type": "application/x-www-form-urlencoded" },
         body: encode({ "form-name": "contact", ...data })
      })
         .then(() => props.onSubmit())
         .catch((error) => {
            console.error(error);
            alert("Something went wrong... Please try again.");
         });

      e.preventDefault();
   };

   const handleChange = (d) => {
      setData({ ...data, ...d });
   };
   return (
      <Form
         id="contact-form"
         name="contact"
         method="post"
         onSubmit={(e) => handleSubmit(e)}
      >
         <input type="hidden" name="form-name" value="contact-form" />
         <Form.Group className="mx-0 animate fade slideY">
            <Form.Field>
               <TextInput
                  label="Name"
                  name="name"
                  onChange={() => handleChange({ name: name.value })}
                  ref={(el) => (name = el)}
                  required
                  size="lg"
               />
            </Form.Field>
         </Form.Group>
         <Form.Group className="mx-0 animate fade slideY delay-125">
            <Form.Field>
               <TextInput
                  label="Email"
                  name="email"
                  onChange={() => handleChange({ email: email.value })}
                  ref={(el) => (email = el)}
                  required
                  size="lg"
                  type="email"
               />
            </Form.Field>
         </Form.Group>
         <Form.Group className="mx-0 animate fade slideY delay-25">
            <Form.Field>
               <TextArea
                  label="Message"
                  name="message"
                  onChange={() => handleChange({ message: message.value })}
                  placeholder="what can I do for you?"
                  ref={(el) => (message = el)}
                  required
                  rows={5}
                  style={{ resize: "none", overflow: "auto" }}
               />
            </Form.Field>
         </Form.Group>
         <Form.Group className="mx-0 animate fade slideY delay-325">
            <Form.Field>
               <Submit size="lg" variant="success" stretch>
                  <strong>SEND &#10148;</strong>
               </Submit>
            </Form.Field>
         </Form.Group>
      </Form>
   );
};

export default ContactForm;
